import { createFileRoute, Link, Outlet } from '@tanstack/react-router';
import { requireScope } from '~/auth/utils';
import { ScrollArea } from '~/primitives/scroll-area';
import { Button } from '~/primitives/button';
import { LogOut } from 'lucide-react';
import { useApiMutation } from '~/util/hooks/useApiMutation';
import { claimMergeRequestMutation } from '~/util/mutations/staff/merges';
import { seo } from '~/util';
import { useScopes } from '~/components/Providers/AuthProvider';

export const Route = createFileRoute('/_authenticated/staff/_mergesLayout')({
    beforeLoad: async ({ context: { auth } }) => {
        requireScope(auth, 'merge_review');
    },
    component: Merges,
    head: () => ({
        meta: seo({
            title: 'Merge Requests Review',
        }),
    }),
});

function Merges() {
    const navigate = Route.useNavigate();
    const claimMerge = useApiMutation({
        ...claimMergeRequestMutation(),
        onSuccess: ({ data }) => {
            navigate({
                to: '/staff/merges/$requestid',
                params: { requestid: data.id },
                search: (prev) => prev,
            });
        },
    });

    const { hasScope } = useScopes();

    return (
        <main className="h-full flex justify-center">
            <div className="flex flex-col items-center gap-4 w-full h-full bg-background-dark rounded-2xl py-4">
                <ScrollArea className="w-full p-4 lg:h-[calc(100vh-150px)]">
                    <div className="flex flex-col xl:flex-row xl:justify-between items-center my-2 gap-2">
                        <div className="flex flex-col xl:flex-row items-center gap-2">
                            <div className="flex items-center gap-2">
                                <Link to="/staff/merges">
                                    <h1 className="text-secondary-foreground hover:text-secondary-light transition-colors">
                                        Merge Requests Review
                                    </h1>
                                </Link>
                            </div>
                        </div>
                        <div className="flex flex-col lg:flex-row lg:items-end gap-2">
                            <Button onClick={() => claimMerge.mutate()}>
                                <LogOut /> Claim a merge request
                            </Button>
                            {hasScope('direct_merge') && (
                                <Button asChild>
                                    <Link to="/staff/merges/direct">
                                        Direct merge
                                    </Link>
                                </Button>
                            )}
                        </div>
                    </div>
                    <Outlet />
                </ScrollArea>
            </div>
        </main>
    );
}
